<template>
    <vgloballayout
        :loading="loading"
        :error="error"
        @reload="newsListLoad"
    >
        <div slot=body>
            <el-row type="flex" class="row-bg" justify="space-between">
                <el-col :span="12"><h1>Новости</h1></el-col>
                <el-col :span="12" class="m-t-15" style="text-align: right">
                    <el-button size="small" @click="addNews" type="primary">Добавить новость</el-button>
                </el-col>
            </el-row>
            <el-table
                v-loading="loadingTablePaginat"
                empty-text="Записи отсутствуют"
                :data="getNewsList.filter(data => !search || data.name.toLowerCase().includes(search.toLowerCase()))"
                style="width: 100%">
                <el-table-column
                    label="#"
                    prop="id">
                </el-table-column>
                <el-table-column
                    label="Дата"
                    prop="date"
                >
                    <template slot-scope="scope">
                        {{ dateReturnFormat(scope.row.date) }}      
                    </template>
                </el-table-column>
                <el-table-column
                    label="Заголовок"
                    prop="title">
                </el-table-column>
                <el-table-column
                    width="240"
                    >


                    <template slot-scope="scope">
                        <el-row type="flex" class="row-bg" justify="space-between">
                        <el-button
                            size="mini"
                            @click="handleEdit(scope.$index, scope.row)">
                            Редактировать
                        </el-button>
                        <el-button
                            size="mini"
                            type="danger"
                            @click="deleteItem(scope.$index, scope.row)">
                            Удалить
                        </el-button>
                        
                        </el-row>
                    </template>
                    
                </el-table-column>
            </el-table>
            <el-row type="flex"  class="m-t-35" justify="center">
                <el-pagination
                    background
                    layout="prev, pager, next"
                    @current-change="handleCurrentChange"
                    :current-page.sync="currentPage"
                    :page-count="totalPages"
                    >
                </el-pagination>
             </el-row>
        </div>
    </vgloballayout>
</template>

<script>
    import { dateReturnFormat } from '@/plugins/methods'

    import { mapGetters } from 'vuex'

	export default {
		data() {
			return {
                loading: false,
                loadingTablePaginat: false,
                error: false,
                search: '',
                currentPage: 1,
                totalPages: 1,
                
			}
        },
        computed: {
            ...mapGetters([
                'getNewsList'
            ])
        },
        mounted() {
            this.newsListLoad()
        },
		methods: {
            dateReturnFormat(date) {
                return dateReturnFormat(date)
            },
            async handleCurrentChange(val) {
                this.loadingTablePaginat = true
                this.error = false

                try {
                    let query = await this.$store.dispatch('getNews', {
                        page: val
                    })

                    this.currentPage = query.page
                    this.totalPages = query.totalPages
                } catch(e) {
                   this.error = this.$ErrorsMod(e)
                }

                this.loadingTablePaginat = false
            },
			handleEdit(index, row) {
                this.$router.push({path: '/news/edit/'+row.id})
			},

            addNews() {
                this.$router.push({path: '/news/add'})
            },
            async deleteItem(index, row, element) {
	            this.$confirm(`Вы действительно хотите удалить новость ?`, 'Подтвердите действие', {
					confirmButtonText: 'Удалить',
					cancelButtonText: 'Отменить',
					type: 'warning'
				}).then( async () => {
                    try {
                        await this.$store.dispatch('newsDelete', {
                            id: row.id,
                            index: index
                        })
                    } catch(e) {
                        this.$ErrorsMod(e)
                    }
                })

            },

            async newsListLoad(page = 1) {
                this.loading = true
                this.error = false

                try {
                    let query = await this.$store.dispatch('getNews', {
                        page: page
                    })

                    this.currentPage = query.page
                    this.totalPages = query.totalPages
                } catch(e) {
                   this.error = this.$ErrorsMod(e)
                }

                this.loading = false
            }
        },
        components: {
            
        }
	}
</script>
